module.exports = __webpack_public_path__ + "ui-static/img/alerts-no-items_light.04c3bdea.svg";